'use strict';

angular.module('ClinicApp').directive('permissionList', function($q, PermissionService, GrowlService) {
  return {
    scope: {
      permissions: '=',
      modelType: '=',
      modelId: '=',
    },
    templateUrl: '/views/directives/_permission-list.html',
    link: function($scope) {
      $scope.newAdministrator = {
        email: null,
      };

      $scope.addPermission = function(form) {
        if (form.$invalid) {
          return $q.reject();
        }
        return PermissionService.createPermission(
          $scope.modelType,
          $scope.modelId,
          $scope.newAdministrator.email,
        ).then(function() {
          $scope.newAdministrator.email = null;
          form.$setPristine();
          $scope.permissionFormSubmitted = false;
          $scope.$emit('reloadPermissions');
        });
      };

      $scope.removePermission = function(permission) {
        return PermissionService.removePermission(
          $scope.modelType,
          $scope.modelId,
          permission.user.id,
        ).then(function() {
          $scope.$emit('reloadPermissions');
        });
      };

      $scope.resendVerification = function(permission) {
        var expectedMessage = 'The permission you entered is invalid. This field must be unique.';
        GrowlService.suppress.addMessage(expectedMessage);
        return PermissionService.createPermission($scope.modelType, $scope.modelId, permission.user.email)['finally'](function() {
          GrowlService.suppress.removeMessage(expectedMessage);
        });
      };
    },
  };
});
